/**
 * Página /sin-permiso del frontend-superadmin.
 *
 * Sprint 11 v2 S11-V2-11. Se llega aquí si un usuario autenticado
 * intenta entrar al panel super_admin sin tener el rol. No es un
 * error de configuración: lo común es que un vecino haga click por
 * error en una URL del panel técnico.
 */
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth/AuthContext';

export function SinPermiso() {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSalir() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="min-h-screen bg-bg-page flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-bg-card border-2 border-admin-red rounded-lg p-8 text-center">
        <h1 className="text-xl font-medium text-text-primary mb-2">
          Sin permiso
        </h1>
        <p className="text-sm text-text-secondary mb-6">
          Tu cuenta no tiene acceso al panel super_admin. Si llegaste aquí
          por error, vuelve al portal de vecinos.
        </p>
        <button
          type="button"
          onClick={handleSalir}
          className="bg-admin-red hover:bg-admin-red/85 text-white font-medium py-2 px-4 rounded-sm transition-colors"
        >
          Cerrar sesión
        </button>
      </div>
    </div>
  );
}
